import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { uiLoggerNamesTaskBoard, uiLoggerNamesWorkflow } from "src/Utils/Recon/UiLogger/Constants";
import uiLogger from "src/Utils/UiLogger";
import { NdButton } from "../PartnerCommunication/MsmePartnerPortal/CommonComponents";
import { StateDispatch } from "../Recon360";

interface UpdateBulkTasksConfirmationModalProps {
  type: string;
  open: boolean;
  setOpen: StateDispatch<boolean>;
  title: string;
  content: any;
  updateBulkTasks: any;
  isLoading: boolean;
  companyId: string;
  branchCode: string;
}
export default function UpdateBulkTasksConfirmationModal({
  type,
  open,
  setOpen,
  title,
  content,
  updateBulkTasks,
  isLoading,
  companyId,
  branchCode,
}: UpdateBulkTasksConfirmationModalProps) {
  return (
    <Dialog open={open} sx={{ "& .MuiDialog-paper": { borderRadius: "4px", minWidth: "600px" } }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Alert severity="info">{content}</Alert>
      </DialogContent>
      <DialogActions sx={{ padding: 2 }}>
        <Button
          variant="text"
          onClick={() => {
            if (type === "taskBoard") {
              uiLogger(
                uiLoggerNamesTaskBoard.UI_WF_TB_BULKTASKS_UPDATETASKS_UPDATE_CANCEL_CLICK.functionName,
                companyId,
                branchCode,
                {
                  message: uiLoggerNamesTaskBoard.UI_WF_TB_BULKTASKS_UPDATETASKS_UPDATE_CANCEL_CLICK.message,
                }
              );
            }
            if (type === "workflow") {
              uiLogger(
                uiLoggerNamesWorkflow.UI_WF_DB_BULKTASKS_UPDATETASKS_UPDATE_CANCEL_CLICK.functionName,
                companyId,
                branchCode,
                {
                  message: uiLoggerNamesWorkflow.UI_WF_DB_BULKTASKS_UPDATETASKS_UPDATE_CANCEL_CLICK.message,
                }
              );
            }
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <NdButton
          disabled={isLoading}
          variant="contained"
          onClick={() => {
            if (type === "taskBoard") {
              uiLogger(
                uiLoggerNamesTaskBoard.UI_WF_TB_BULKTASKS_UPDATETASKS_UPDATE_UPDATE_CLICK.functionName,
                companyId,
                branchCode,
                {
                  message: uiLoggerNamesTaskBoard.UI_WF_TB_BULKTASKS_UPDATETASKS_UPDATE_UPDATE_CLICK.message,
                }
              );
            }
            if (type === "workflow")
              uiLogger(
                uiLoggerNamesWorkflow.UI_WF_DB_BULKTASKS_UPDATETASKS_UPDATE_CLICK.functionName,
                companyId,
                branchCode,
                {
                  message: uiLoggerNamesWorkflow.UI_WF_DB_BULKTASKS_UPDATETASKS_UPDATE_CLICK.message,
                }
              );
            updateBulkTasks();
          }}
        >
          <LoadingIcon loading={isLoading} />
          Update
        </NdButton>
      </DialogActions>
    </Dialog>
  );
}
